
<div class="container">
    <div class="row align-items-center">

        <div class="col-12 col-lg-6 offset-lg-3 typo_3 text-center mb-32r">
            <ng-content select="[content-center]"></ng-content>
        </div>

    </div>
</div>